import React from 'react';
import CommonInput, { CommonInputProps } from '.';

type PositiveNumberInputProps = Omit<CommonInputProps, 'type' | 'min'>;

export default function PositiveNumberInput(props: PositiveNumberInputProps) {
    return <CommonInput {...props} type="number" min="1" />;
}